import { render, staticRenderFns } from "./GroupNote.vue?vue&type=template&id=72f54bdc"
import script from "./GroupNote.vue?vue&type=script&lang=js"
export * from "./GroupNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports